import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useId, useRef, useState } from 'react'

interface CarouselContainerItem {
    title?: string,
    content: React.ReactNode
}

interface CarouselContainerProps {
    width?: string,
    height?: string,
    items: CarouselContainerItem[],
    hideItemArrowControl?: boolean,
    timer?: boolean
}

export default function CarouselContainer({ width = '100%', height = 'auto', items, hideItemArrowControl, timer = true }: CarouselContainerProps) {
    const [pause, setPause] = useState(false);
    const [itemView, setItemView] = useState(0)
    const carouselRef = useRef<HTMLDivElement>(null);
    const carouselContainerId = useId()
    function scrollCarousel(factor: number) {
        setPause(!pause)
        setItemView(itemView + factor)
    }
    useEffect(() => {
        let target = carouselRef.current
        if (target) {
            let width = target?.clientWidth * itemView
            target.scrollTo({
                left: width,
                behavior: "smooth"
            });
        }
    }, [itemView])

    useEffect(() => {
        let timer: any = null
        if (!pause && timer) {
            timer = setInterval(() => {
                setItemView((state) => {
                    let idx = state + 1
                    return idx >= items.length ? 0 : idx
                })
            }, 7500);
        } else if (pause) {
            clearInterval(timer);
        }
        return () => clearInterval(timer);
    }, [items, timer])

    return (
        <div className='carousel' style={{ width, height }}>
            <div className='carousel-items' ref={carouselRef}>
                {items.map((item, idx) => <div className='carousel-item' key={idx}>
                    <div className='carousel-item-content'>{item.content}</div>
                    {item.title && <div className='carousel-item-title'>{item.title}</div>}
                </div>)}
            </div>
            {items.length > 1 && <>
                <div className='carousel-option'>
                    {itemView > 0 && !hideItemArrowControl && <button className='carousel-option-left' onClick={() => scrollCarousel(-1)}>
                        <FontAwesomeIcon icon="arrow-left" />
                    </button>}
                    {itemView < (items.length - 1) && !hideItemArrowControl && <button className='carousel-option-right' onClick={() => scrollCarousel(1)}>
                        <FontAwesomeIcon icon="arrow-right" />
                    </button>}
                </div>
                <div className='carousel-index'>
                    {items.map((_, idx) => <input
                        type="radio"
                        id={`carousel-index-${idx}`}
                        name={carouselContainerId}
                        value={idx}
                        checked={idx === itemView}
                        onChange={() => setItemView(idx)}
                        key={idx}
                    />)}
                </div>
            </>}
        </div>
    )
}
